import { NotificationRepetitionType } from "../../../constants";

export const EveryTypeOptions = [
  {
    label: "Days",
    value: NotificationRepetitionType.Daily
  },
  {
    label: "Weeks",
    value: NotificationRepetitionType.Weekly
  }
];

export const MoreLessOptions = [
  {
    label: "More than",
    value: "moreThan"
  },
  {
    label: "Less than",
    value: "lessThan"
  }
];
